import { StepProps } from "~/components/organisms/step";

import { Button, Icon } from "@Rolec-Services/rolec-ui";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Tier as TierType } from "~/schemas/forms/onboarding";
import { Compare } from "./compare";
import { TierData } from "./data";
import { Table } from "./table";
import { Tier } from "./tier";

type TiersProps = {
  setValue: StepProps["setValue"];
  nextStep: () => void;
};

export function Tiers({ setValue, nextStep }: TiersProps) {
  const { t } = useTranslation();
  const { tiers, info } = TierData(t);

  const [compare, setCompare] = useState(false);

  function updateCompare() {
    setCompare(!compare);
  }

  function onClick(tier: TierType) {
    setValue("tier", tier);
    nextStep();
  }

  const buttons = [
    {
      onClick: () => onClick("basic"),
    },
    {
      onClick: () => onClick("basic"),
    },
    // {
    //   onClick: () => onClick("sponsored"),
    // },
    {
      onClick: () => onClick("commercial"),
    },
  ];

  if (compare) return <Compare t={t} buttons={buttons} />;

  return (
    <div className="flex flex-col h-full gap-16 w-full">
      <div className="flex justify-between w-full gap-4">
        {tiers.map((tier, index) => (
          <Tier key={`tier-${index}`} {...tier} />
        ))}
      </div>

      <div className="flex flex-col gap-4 h-full">
        <Table info={info} />
        <div className="flex justify-between w-full gap-2">
          {buttons.map((button, index) =>
            index === 0 ? (
              <div
                key={`tier-header-placeholder-${index}`}
                className="flex flex-row justify-center w-full"
              />
            ) : (
              <div
                key={`tier-button-${index}`}
                className="flex flex-row justify-center w-full"
              >
                <Button
                  key={`tier-button-${index}`}
                  type="button"
                  onClick={button.onClick}
                >
                  {t("Confirm")}
                  <Icon icon="ArrowRight" />
                </Button>
              </div>
            )
          )}
        </div>

        <p className="text-center">
          {t("Which option is best suited to your situation?")}
          <span
            onClick={() => updateCompare()}
            className="text-ev-500 hover:cursor-pointer pl-1"
          >
            {t("Compare")}
          </span>
        </p>
      </div>
    </div>
  );
}
